import OnFilesAddedHandler from './handlers/OnFilesAddedHandler';
import OnFileRemovedHandler from './handlers/OnFileRemovedHandler';
import OnFileSelectedHandler from './handlers/OnFileSelectedHandler';
import OnDescriptionChangedHandler from './handlers/OnDescriptionChangedHandler';
import OnProviderChangedHandler from './handlers/OnProviderChangedHandler';
import OnClearHandler from './handlers/OnClearHandler';
import OnPushAllHandler from './handlers/OnPushAllHandler';

/**
 * Creates the handlers map for UploadAttachmentHandler.
 * Add new event handlers here — _onEvent picks them up automatically.
 */
export default class UploadAttachmentHandlerFactory {

    /**
     * @param {object} state - shared upload state from UploadAttachmentHandler
     * @returns {object} map of event name -> handler instance
     */
    create(state) {
        return {
            onFilesAdded: new OnFilesAddedHandler(state),
            onFileRemoved: new OnFileRemovedHandler(state),
            onFileSelected: new OnFileSelectedHandler(state),
            onDescriptionChanged: new OnDescriptionChangedHandler(state),
            onProviderChanged: new OnProviderChangedHandler(state),
            onClear: new OnClearHandler(state),
            onPushAll: new OnPushAllHandler(state),
        };
    }
}
